import { render, staticRenderFns } from "./Mes.vue?vue&type=template&id=2a553728&scoped=true&"
import script from "./Mes.vue?vue&type=script&lang=js&"
export * from "./Mes.vue?vue&type=script&lang=js&"
import style0 from "./Mes.vue?vue&type=style&index=0&id=2a553728&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a553728",
  null
  
)

export default component.exports